/** @file discreteFields: the fields of a node key that switch rather than interpolate (parent, toggles). */
import type { NodeKey } from '@zilo/pose3d-format/types/clip';

/** `parent`, `rotToggle` and `hidden` of `key` (those present). */
export function discreteFields(key: NodeKey): Pick<NodeKey, 'parent' | 'rotToggle' | 'hidden'> {
  return {
    ...(key.parent === undefined ? {} : { parent: key.parent }),
    ...(key.rotToggle === undefined ? {} : { rotToggle: key.rotToggle }),
    ...(key.hidden === undefined ? {} : { hidden: key.hidden }),
  };
}
